var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkbench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3429 3.47514L13.409 7.40906L13.9393 10.0607L16.5909 10.591L20.5249 6.65712L20.5252 6.65695C21.0122 7.80636 21.1286 9.07897 20.8584 10.2977C20.5882 11.5164 19.9447 12.6205 19.0176 13.4563C18.0905 14.2922 16.9258 14.8182 15.6857 14.9612C14.4457 15.1041 13.1919 14.8569 12.0989 14.2539L12.099 14.2537L6.84094 20.341C6.4189 20.7626 5.84673 20.9993 5.25021 20.9991C4.6537 20.999 4.08166 20.7619 3.65986 20.3401C3.23806 19.9183 3.00102 19.3463 3.00085 18.7498C3.00068 18.1533 3.2374 17.5811 3.65896 17.1591L9.74627 11.9011L9.74615 11.9011C9.14314 10.8081 8.8959 9.55434 9.03885 8.31427C9.18179 7.07419 9.7078 5.90953 10.5437 4.98241C11.3795 4.05528 12.4836 3.41182 13.7023 3.1416C14.921 2.87137 16.1936 2.98783 17.343 3.47475L17.3429 3.47514Z",
    stroke: "#262D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkbench);
export default __webpack_public_path__ + "static/media/Workbench.97595313dd8545a3f1c28a480aa0869a.svg";
export { ForwardRef as ReactComponent };